// extracted by mini-css-extract-plugin
export var container = "_bd-0";
export var icon = "_bd-1";
export var text = "_bd-2";